import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-6">
            <img 
              src="/logo.png" 
              alt="3afer" 
              className="w-12 h-12 object-contain"
              onError={(e) => {
                // Hide logo if it fails to load (404)
                e.target.style.display = 'none'
              }}
            />
            <span className="text-3xl font-bold text-white">عافر</span>
          </div>
          <p className="text-sm leading-relaxed mb-6 text-gray-400">
          منصة تعليمية متخصصة للتجاريين تهدف إلى تطوير مهارات الطلاب والخريجين بتوفير دورات تدريبية متكاملة بتقنية عالية ومحاضرين محترفين
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-blue transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 19V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2z"/>
                <path d="M22 10a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2z"/>
                <path d="M15 7h.01"/>
              </svg>
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-blue transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Links */}
        <div>
          <h4 className="text-white font-bold text-lg mb-6">روابط سريعة</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-accent-orange transition-colors">الرئيسية</Link></li>
            <li><Link to="/courses" className="hover:text-accent-orange transition-colors">عن المنصة</Link></li>
            <li><Link to="/courses" className="hover:text-accent-orange transition-colors">الدورات المتاحة</Link></li>
            <li><Link to="/community" className="hover:text-accent-orange transition-colors">المدونة</Link></li>
          </ul>
        </div>

        {/* Support */}
        <div>
          <h4 className="text-white font-bold text-lg mb-6">المساعدة</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/help" className="hover:text-accent-orange transition-colors">الأسئلة الشائعة</Link></li>
            <li><Link to="/terms" className="hover:text-accent-orange transition-colors">الشروط والأحكام</Link></li>
            <li><Link to="/privacy" className="hover:text-accent-orange transition-colors">سياسة الخصوصية</Link></li>
            <li><Link to="/chat" className="hover:text-accent-orange transition-colors">اتصل بنا</Link></li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="text-white font-bold text-lg mb-6">النشرة البريدية</h4>
          <p className="text-sm text-gray-400 mb-4">اشترك ليصلك كل جديد من دورات وعروض.</p>
          <div className="relative">
            <input
              type="email"
              placeholder="بريدك الإلكتروني"
              className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 px-4 focus:outline-none focus:border-primary-blue text-white placeholder-gray-500"
            />
            <button className="absolute left-1 top-1 bottom-1 bg-primary-blue hover:bg-[#0052a3] text-white px-4 rounded-md transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m12 19-7-7 7-7"/>
                <path d="M19 12H5"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 pt-8 mt-12 border-t border-gray-800 text-center text-sm text-gray-500">
        © {currentYear} منصة عافر التعليمية. جميع الحقوق محفوظة.
      </div>
    </footer>
  )
}

export default Footer

